import React, { Fragment, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ModalPop from "components/sales/modal/modal";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { toast } from "react-toastify";

const AssignReportee = ({
  showAssignLocationPopup,
  onClosePopup = () => {},
  locationAssignUserId,
  departmentDropwdownResponse,
  teamDropdownResponse,
  reportingManagerResponse,
  departmentId,
  teamId,
  reportingToRoleId,
  reportingToRoleLevel,
  reportingManagerDropdownData,
  assignReporteeToUser,
}) => {
  const [locations, setLocations] = useState([
    { city_id: "", zone_id: "", zoneOptions: [] },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [reporteeData, setReporteeData] = useState([
    { department_id: "", team_id: "", reporting_to: "" },
  ]);

  const handleSubmit = async () => {
    const payload = {
      user_id: locationAssignUserId,
      department_id: departmentId,
      team_id: reporteeData?.team_id || teamId,
      reporting_to: reporteeData?.reporting_to,
    };
    onClosePopup();
    setIsLoading(true);
    const res = await assignReporteeToUser(payload);
    if (res?.status === 200) {
      setSuccessModal(true);
    } else {
      toast.error(res?.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const fetchReportingManagerData = async () => {
      setIsLoading(true);
      await reportingManagerDropdownData(
        departmentId,
        teamId,
        reportingToRoleLevel
      );
      setIsLoading(false);
    };

    fetchReportingManagerData();
  }, [departmentId, teamId, reportingToRoleLevel]);

  useEffect(() => {
    setReporteeData((prev) => ({
      ...prev,
      department_id: departmentId,
      team_id: teamId,
    }));
  }, [departmentId, teamId]);

  const handleSuccessModalHide = () => {
    setSuccessModal(false);
  };

  return (
    <>
      <ModalPop
        title={"Assign Reportee"}
        show={showAssignLocationPopup}
        handleModalHide={onClosePopup}
      >
        <Fragment>
          <div className="row">
            <div className="col-md-4">
              <DropDownInput
                data={departmentDropwdownResponse?.response?.data}
                label={localization.department}
                required
                errorMsg={localization.required}
                isStarRequired={true}
                getValueById={departmentId}
                disabled
              />
            </div>
            <div className="col-md-4">
              <DropDownInput
                data={teamDropdownResponse?.response?.data}
                label={localization.team}
                required
                getIdValue={(val) => {
                  setReporteeData((prev) => ({ ...prev, team_id: val.id }));
                }}
                errorMsg={localization.required}
                isStarRequired={true}
                getValueById={reporteeData?.team_id || teamId}
              />
            </div>
            <div className="col-md-4">
              <DropDownInput
                data={reportingManagerResponse?.response?.data}
                label={"Reporting To"}
                required
                getIdValue={(val) => {
                  setReporteeData({ ...reporteeData, reporting_to: val.id });
                }}
                errorMsg={localization.required}
                isStarRequired={true}
              />
            </div>
          </div>

          <div className="d-flex mt-3" style={{ justifyContent: "flex-start" }}>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              Submit
            </button>
          </div>
        </Fragment>
      </ModalPop>

      <ModalPop
        title={localization.success}
        show={successModal}
        handleModalHide={handleSuccessModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{"Reporting to Assigned Successfully"}</h5>
          <button
            className="btn btn-primary mb-4"
            onClick={() => window.location.reload()}
          >
            {"Close"} <img src={Images?.ArrowRight} alt="" />
          </button>
        </div>
      </ModalPop>
    </>
  );
};

AssignReportee.propTypes = {
  departmentDropwdownResponse: PropTypes.any,
  teamDropdownResponse: PropTypes.any,
  reportingManagerResponse: PropTypes.func,
  showAssignLocationPopup: PropTypes.bool,
  onClosePopup: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(null, mapDispatchToProps)(AssignReportee);
